import { Action, type GlobalIdentifierObject, type GlobalIdentifierOperator } from '../../../../common/types';
import { AiFillCaretDown } from 'react-icons/ai';
import { generateGlobalIdentifierByName } from '../../helpers';
import GlobalIdentifierComponent from './GlobalIdentifierComponent';
import { globalIdentifierOperators } from '../../constants';
import { useState } from 'react';

interface IProps {
  identifiers: GlobalIdentifierObject[];
  handleChange: (action: Action, value: GlobalIdentifierObject) => void;
}

const GlobalIdentifiers: React.FC<IProps> = ({ identifiers, handleChange }) => {
  const [openGlobalIdentifierSelectionButton, setOpenGlobalIdentifierSelectionButton] = useState(false);

  const handleToggleGlobalIdentifierSelection = (): void => {
    setOpenGlobalIdentifierSelectionButton(!openGlobalIdentifierSelectionButton);
  };

  const handleGlobalIdentifierOperatorTypeSelection = (globalIdentifierOperator: GlobalIdentifierOperator): void => {
    handleChange(Action.ADD, generateGlobalIdentifierByName(identifiers.length, globalIdentifierOperator));
    setOpenGlobalIdentifierSelectionButton(false);
  };

  return (
    <div className="flex flex-col space-y-2 w-full">
      <div className="flex justify-between items-center">
        <div className="text-xl">Global Identifier Builder</div>
        <div className="relative inline-block text-left">
          <div>
            <button
              type="button"
              onClick={handleToggleGlobalIdentifierSelection}
              className="inline-flex justify-center items-center text-white gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm bg-primary"
              id="global-identifier-operator-type-button"
              aria-expanded="true"
              aria-haspopup="true"
            >
              <span>Add Global identifier</span>
              <AiFillCaretDown />
            </button>
          </div>
          <div>
            {openGlobalIdentifierSelectionButton && (
              <div
                className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="global-identifier-operator-type-button"
                tabIndex={-1}
              >
                <div className="py-1" role="none">
                  {globalIdentifierOperators.map((operator, index) => {
                    return (
                      <a
                        key={index}
                        className="text-gray-700 block px-4 py-2 text-sm hover:bg-primary hover:text-white focus:outline-none"
                        role="menuitem"
                        tabIndex={-1}
                        id={`menu-item-${index}`}
                        onClick={() => {
                          handleGlobalIdentifierOperatorTypeSelection(operator.value);
                        }}
                      >
                        {operator.label}
                      </a>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        {identifiers?.map((globalIdentifier) => {
          return (
            <GlobalIdentifierComponent
              key={globalIdentifier.id}
              identifier={globalIdentifier}
              handleChange={handleChange}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GlobalIdentifiers;
